import { createListStore } from "./list";
import { FieldsService } from "@/services/fields";

export const useFieldsStore = createListStore("fields", FieldsService);
